import React from 'react';
import { SvgIcon } from '@mui/material';

function OutOfStockSVG(props) {
  return (
    <SvgIcon width="39" height="39" viewBox="0 0 39 39" fill="none" {...props}>
      {/* <svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39" fill="none"></svg> */}
      <path
        d="M19.267 35.2679C17.9658 35.2679 16.7218 34.743 14.2354 33.6962C8.04581 31.089 4.9502 29.7862 4.9502 27.5925V12.2687M19.267 35.2679C20.5683 35.2679 21.8122 34.743 24.2986 33.6962C30.4882 31.089 33.5838 29.7862 33.5838 27.5925V12.2687M19.267 35.2679V19.4081M4.9502 12.2687C4.9502 13.2439 6.22598 13.8595 8.77597 15.0892L13.421 17.3321C16.2907 18.7161 17.724 19.4081 19.267 19.4081M4.9502 12.2687C4.9502 11.2952 6.22598 10.6796 8.77597 9.44991L11.3132 8.22503M33.5838 12.2687C33.5838 13.2439 32.308 13.8595 29.7581 15.0892L25.113 17.3321C22.2433 18.7161 20.81 19.4081 19.267 19.4081M33.5838 12.2687C33.5838 11.2952 32.308 10.6796 29.7581 9.44991L27.2208 8.22503M9.72247 20.9925L12.904 22.5784M16.0855 3.45276L19.267 6.63427M19.267 6.63427L22.4485 9.81579M19.267 6.63427L16.0855 9.81579M19.267 6.63427L22.4485 3.45276"
        stroke={props.strokeColor}
        strokeWidth="2.38614"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* </svg> */}
    </SvgIcon>
  );
}
export default OutOfStockSVG;
